export const DEFAULT_OPTION_HEIGHT = 32;

export const virtualizedDropdownStyles = (width, menuWidth) => ({
  control: (base, state) => ({
    ...base,
    width: width || "100%",
    background: "#050505",
    borderColor: state.isFocused ? "#666" : "#444",
    borderRadius: 8,
    color: "rgba(187,187,187,0.75)",
    minHeight: "38px",
    alignItems: "flex-start",
  }),
  valueContainer: (base) => ({
    ...base,
    flexWrap: "wrap",
    gap: "4px",
    padding: "2px 8px",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#222",
    color: "#fff",
    fontFamily: '"Segoe UI", sans-serif',
    maxWidth: "100%",
    margin: "1px",
  }),
  multiValueLabel: (base) => ({ ...base, color: "#fff" }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#aaa",
    cursor: "pointer",
    ":hover": { backgroundColor: "#333", color: "#fff" },
  }),
  input: (base) => ({
    ...base,
    color: "rgba(187,187,187,0.75)",
    margin: "2px",
  }),
  placeholder: (base) => ({ ...base, color: "rgba(187,187,187,0.75)" }),
  singleValue: (base) => ({ ...base, color: "rgba(187,187,187,0.75)" }),
  menu: (base) => ({
    ...base,
    background: "#111",
    color: "#fff",
    border: "1px solid #333",
    zIndex: 11000,
    fontFamily: '"Segoe UI", sans-serif',
    width:
      menuWidth === "100%" || menuWidth === "full" ? "100%" : menuWidth || 440,

    left: 0,
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 700,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#222" : "#111",
    color: "#fff",
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: "14px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    padding: "8px 12px",
    minHeight: `${DEFAULT_OPTION_HEIGHT}px`,
    alignItems: "flex-start",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 11000 }),
  noOptionsMessage: (base) => ({
    ...base,
    whiteSpace: "normal",
    wordBreak: "break-word",
    padding: "12px",
  }),
  clearIndicator: (base) => ({ ...base, cursor: "pointer" }),
  dropdownIndicator: (base) => ({ ...base, cursor: "pointer" }),
});
